// extracted by mini-css-extract-plugin
module.exports = {"section":"SolutionAI_section__aym1v","title":"SolutionAI_title__l4xd8","subtitle":"SolutionAI_subtitle__930Ov","image":"SolutionAI_image__2rcBH"};